import React, { useState, useEffect } from 'react';
import Nav from './Nav';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

   useEffect(() => {
    // 1. Load CSS
    const stylesheets = [
      "/assets/plugins/bootstrap-touchspin/jquery.bootstrap-touchspin.css",
      "/assets/plugins/daterangepicker/daterangepicker.css",
       "/assets/plugins/select2/select2.min.css",
      "/assets/plugins/switchery/switchery.min.css",
      "/assets/plugins/bootstrap-colorpicker/bootstrap-colorpicker.min.css",
      "/assets/plugins/bootstrap-datepicker/bootstrap-datepicker.min.css",
      "/assets/plugins/quill/quill.core.css",
      "/assets/plugins/quill/quill.bubble.css",
      "/assets/plugins/quill/quill.snow.css",
      "/assets/plugins/summernote/summernote-bs4.min.css",
      "/assets/plugins/dropify/dropify.min.css",
      "/assets/plugins/datatables/dataTables.bootstrap4.css",
      "/assets/plugins/datatables/responsive.bootstrap4.css",
      "/assets/plugins/datatables/buttons.bootstrap4.css",
      "/assets/plugins/datatables/select.bootstrap4.css",
      "/assets/plugins/sweetalert2/sweetalert2.min.css",
      "/assets/css/bootstrap.css",
      "/assets/css/icons.min.css",
      "/assets/css/theme.css",
    ];

    const linkElements = stylesheets.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });

    // 2. Load JS scripts in order
    const scripts = [
      "/assets/js/jquery.min.js",
      "/assets/js/bootstrap.bundle.min.js",
      "/assets/js/metismenu.min.js",
      "/assets/js/waves.js",
      "/assets/js/simplebar.min.js",
      "/assets/plugins/autonumeric/autoNumeric-min.js",
      "/assets/plugins/bootstrap-datepicker/bootstrap-datepicker.min.js",
      "/assets/plugins/bootstrap-maxlength/bootstrap-maxlength.min.js",
      "/assets/plugins/moment/moment.js",
      "/assets/plugins/daterangepicker/daterangepicker.js",
      "/assets/plugins/select2/select2.min.js",
      "/assets/plugins/switchery/switchery.min.js",
      "/assets/plugins/bootstrap-colorpicker/bootstrap-colorpicker.min.js",
      "/assets/plugins/bootstrap-touchspin/jquery.bootstrap-touchspin.min.js",
      "/assets/plugins/katex/katex.min.js",
      "/assets/plugins/summernote/summernote-bs4.min.js",
      "/assets/plugins/dropify/dropify.min.js",
      "/assets/pages/fileuploads-demo.js",
      "/assets/pages/advanced-plugins-demo.js",
      "/assets/plugins/jquery-mask/jquery.mask.min.js",
      "/assets/pages/mask-demo.js",
      "/assets/plugins/datatables/jquery.dataTables.min.js",
      "/assets/plugins/datatables/dataTables.bootstrap4.js",
      "/assets/plugins/datatables/dataTables.responsive.min.js",
      "/assets/plugins/datatables/responsive.bootstrap4.min.js",
      "/assets/plugins/datatables/dataTables.buttons.min.js",
      "/assets/plugins/datatables/buttons.bootstrap4.min.js",
      "/assets/plugins/datatables/buttons.html5.min.js",
      "/assets/plugins/datatables/buttons.flash.min.js",
      "/assets/plugins/datatables/buttons.print.min.js",
      "/assets/plugins/datatables/dataTables.keyTable.min.js",
      "/assets/plugins/datatables/dataTables.select.min.js",
      "/assets/plugins/datatables/pdfmake.min.js",
      "/assets/plugins/datatables/vfs_fonts.js",
      "/assets/pages/datatables-demo.js",
      "/assets/plugins/sweetalert2/sweetalert2.min.js",
      "/assets/js/theme.js",
    ];

    const scriptElements = [];

    const loadScriptSequentially = async () => {
      for (let src of scripts) {
        await new Promise((resolve, reject) => {
          const existing = document.querySelector(`script[src="${src}"]`);
          if (existing) return resolve(); // already loaded

          const script = document.createElement("script");
          script.src = src;
          script.async = false; // Ensure correct load order
          script.onload = resolve;
          script.onerror = () => {
            console.error("Failed to load:", src);
            resolve(); // Continue loading others
          };
          document.body.appendChild(script);
          scriptElements.push(script);
        });
      }
    };

    loadScriptSequentially();

    // 3. Cleanup function on unmount
    return () => {
      linkElements.forEach((link) => {
        if (document.head.contains(link)) {
          document.head.removeChild(link);
        }
      });

      scriptElements.forEach((script) => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);
  
  
  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add('enable-vertical-menu');
    } else {
      document.body.classList.remove('enable-vertical-menu');
    }
   
    return () => {
      document.body.classList.remove('enable-vertical-menu');
    };
  }, [sidebarOpen]);

  const handleMenuToggle = () => setSidebarOpen(open => !open);
  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <div className="layout-wrapper">
      <header id="page-topbar">
        <Nav onMenuToggle={handleMenuToggle} />
      </header>

      <div className={`vertical-menu${sidebarOpen ? ' open' : ''}`}>
        <Sidebar />
      </div>

      {/* Overlay for sidebar on mobile */}
      <div
        className={`menu-overlay${sidebarOpen ? ' show' : ''}`}
        onClick={handleOverlayClick}
        style={{ display: sidebarOpen ? 'block' : 'none' }}
      />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>

        <footer className="main-footer">
          <Footer />
        </footer>
      </div>
    </div>
  );
};

export default AppLayout;